import { useEffect, useRef } from 'react';
import L from 'leaflet';
import { feedWalk } from '../lib/walk';

export default function useLiveLocation(mapRef, follow) {
  const followRef = useRef(follow);
  const lastRef = useRef(null);
  followRef.current = follow;

  useEffect(() => {
    if (!navigator.geolocation) return undefined;
    let dot = null;
    let ring = null;
    const id = navigator.geolocation.watchPosition((pos) => {
      const map = mapRef.current;
      if (!map) return;
      feedWalk(pos);
      const ll = [pos.coords.latitude, pos.coords.longitude];
      lastRef.current = ll;
      if (!dot) {
        ring = L.circle(ll, { radius: pos.coords.accuracy, color: '#2563eb', weight: 1, fillColor: '#3b82f6', fillOpacity: 0.12, interactive: false }).addTo(map);
        dot = L.marker(ll, { icon: L.divIcon({ className: 'live-loc', html: '<span></span>', iconSize: [20, 20], iconAnchor: [10, 10] }), interactive: false, keyboard: false, zIndexOffset: 900 }).addTo(map);
      } else {
        dot.setLatLng(ll);
        ring.setLatLng(ll).setRadius(pos.coords.accuracy);
      }
      if (followRef.current) map.panTo(ll, { animate: true });
    }, () => {}, { enableHighAccuracy: true, maximumAge: 3000, timeout: 20000 });
    return () => { navigator.geolocation.clearWatch(id); dot?.remove(); ring?.remove(); };
  }, [mapRef]);

  useEffect(() => {
    if (follow && lastRef.current) mapRef.current?.setView(lastRef.current, Math.max(mapRef.current.getZoom(), 18));
  }, [follow, mapRef]);
}
